<template>
  <div>
    <page-title>Approved Applications</page-title>
    <search
      :nimasaSearchFunction="loadSearchResultForNimasaFromAPI"
      :clearSearch="params ? true : false"
      :clearSearchFunction="clearSearch"
    ></search>
    <div class="has-background-white has-padding-left-30 has-padding-right-30 has-padding-bottom-15 has-padding-top-15">
      <h2
        class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black has-margin-bottom-10"
      >Approved Application </h2>
      <shipping-requests
        :shipping-requests="shippingRequests"
        :isBackendPaginated="true"
        :currentPage="currentPage"
        :total="total"
        :onPageChange="onPageChange"
      ></shipping-requests>
      <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    </div>
  </div>
</template>

<script>
import ShippingRequests from "@/modules/commonModule/components/shippingRequestsList/Main";
import GetShippingRequestsForNimasa from "@/modules/nimasaAgentModule/api/graphql/queries/GetShippingRequestsForNimasa.gql";
import { NIMASA_AGENT_MUTATION_TYPES } from "@/store/mutation-types";
import SYSTEM_FLAGS from "@/modules/commonModule/helpers/getSystemFlags";
import Search from "@/modules/commonModule/layouts/Search";
import SearchAndFilterQueries from "@/modules/commonModule/api/graphql/queries/SearchAndFilterQueries";

import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("nimasaAgent");

export default {
  name: "approved-applications",
  components: { ShippingRequests, Search },

  data() {
    return {
      isLoading: false,
      currentPage: 1,
      total: 0,
      params: null
    };
  },

  mounted() {

    /**
     * Load shipping requests pending approval
     */
      this.loadShippingRequestsApprovedApplicationsFromAPI(this.currentPage);
    
  },

  computed: {
    ...mapGetters({
      shippingRequestsApprovedApplications: "shippingRequestsApprovedApplications",
      searchQueryData: "getSearchResults"
    }),

    shippingRequests() {   
        if (this.params) {
          return this.searchQueryData;
        } else {
         return this.shippingRequestsApprovedApplications;
        }
      }
  },

  methods: {
    ...mapMutations({
      saveShippingRequestsApprovedApplications:
        NIMASA_AGENT_MUTATION_TYPES.SAVE_SHIPPING_REQUESTS_APPROVED_APPLICATIONS,
      saveNimasaSearchResults:
        NIMASA_AGENT_MUTATION_TYPES.SAVE_NIMASA_SEARCH_RESULTS
    }),

    /**
     * Load shipping requests with the status "APPROVED" from the api and put them in
     * the nimaseAgent store module
     */
    loadShippingRequestsApprovedApplicationsFromAPI: function(page) {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetShippingRequestsForNimasa,
          variables: {
            shipping_request_status:
              SYSTEM_FLAGS.SHIPPING_REQUEST_STATUS.APPROVED,
            page,
            count: 10
          }
        })
        .then(response => {
          const shippingRequests =
            response.data.getShippingRequestsForNimasa.data;
          this.saveShippingRequestsApprovedApplications(shippingRequests);

          const {
            total,
            currentPage
          } = response.data.getShippingRequestsForNimasa.paginatorInfo;
          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Shipping applications loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load shipping requests",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    loadSearchResultForNimasaFromAPI: function(
      page,
      searchQuery,
      startDate,
      endDate,
      userType
    ) {
      this.isLoading = true;

      if (startDate || endDate) {
        this.params = {
          start_date: startDate,
          end_date: endDate,
          search_query: searchQuery,
          user_type: userType,
          page
        };
      } else {
        this.params = {
          search_query: searchQuery,
          user_type: userType,
          page
        };
      }

      this.$apollo
        .query({
          query: SearchAndFilterQueries.SearchAndFilterForNimasa,
          variables: {
            ...this.params
          }
        })
        .then(response => {
          const shippingRequests =
            response.data.SearchAndFilterNimasaShippingRequests.data;
          this.saveNimasaSearchResults(shippingRequests);

          const {
            total,
            currentPage
          } = response.data.SearchAndFilterNimasaShippingRequests.paginatorInfo;

          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "search results loaded",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load seach query please try again",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    clearSearch() {
      if (this.params) {
        this.params = null;
      }
    },

    /**
     * Handle pagination with the back end
     */
    onPageChange(page) {
      this.currentPage = page;
        this.loadShippingRequestsApprovedApplicationsFromAPI(this.currentPage);
    }
  }
};
</script>


